import React from 'react';
import './index.scss';
import { useTranslation } from 'react-i18next';
import LazyImageWithNoscript from '../../common/LazyImageWithNoscript';

const PharmaciesTableLogo = ({ drugName = '' }) => {
  const { t } = useTranslation();
  return (
    <div className="pharmaciesTablesMain">
      <div className="pharmaciesTablesContainer">
        <h2>
          {t('Where are')}&nbsp;<span>{drugName}</span>&nbsp;
          {t('coupons from SingleCare accepted?')}
        </h2>
        <p>{t('SingleCare pharmacies para')}</p>

        <div>
          <ul>
            <li>
              <LazyImageWithNoscript
                src="/content/images/pharmacies-logo/walgreens-logo.svg"
                alt=""
                height="24"
                width="24"
              />
              <label>Walgreens</label>
            </li>
            <li>
              <LazyImageWithNoscript
                src="/content/images/pharmacies-logo/kroger-logo.svg"
                alt=""
                height="24"
                width="24"
              />
              <label>Kroger</label>
            </li>
            <li>
              <LazyImageWithNoscript
                src="/content/images/pharmacies-logo/walmart-logo.svg"
                alt=""
                height="24"
                width="24"
              />
              <label>Walmart</label>
            </li>
            <li>
              <LazyImageWithNoscript
                src="/content/images/pharmacies-logo/cvs-logo.svg"
                alt=""
                height="24"
                width="24"
              />
              <label>CVS Pharmacy</label>
            </li>
            <li>
              <LazyImageWithNoscript
                src="/content/images/pharmacies-logo/taret-logo.svg"
                alt=""
                height="24"
                width="24"
              />
              <label>Target (CVS)</label>
            </li>
            <li>
              <LazyImageWithNoscript
                src="/content/images/pharmacies-logo/kingScoopers-logo.svg"
                alt=""
                height="24"
                width="24"
              />
              <label>King Scoopers</label>
            </li>
            <li>
              <LazyImageWithNoscript
                src="/content/images/pharmacies-logo/smiths-logo.svg"
                alt=""
                height="24"
                width="24"
              />
              <label>Smith’s</label>
            </li>
            <li>
              <LazyImageWithNoscript
                src="/content/images/pharmacies-logo/fredMeyer-logo.svg"
                alt=""
                height="24"
                width="24"
              />
              <label>Fred Meyer</label>
            </li>
            <li>
              <LazyImageWithNoscript
                src="/content/images/pharmacies-logo/frys-logo.svg"
                alt=""
                height="24"
                width="24"
              />
              <label>Fry’s</label>
            </li>
            <li>
              <LazyImageWithNoscript
                src="/content/images/pharmacies-logo/harrisTeeter-logo.svg"
                alt=""
                height="24"
                width="24"
              />
              <label>Harris Teeter</label>
            </li>
            <li>
              <LazyImageWithNoscript
                src="/content/images/pharmacies-logo/ralphs-logo.svg"
                alt=""
                height="24"
                width="24"
              />
              <label>Ralphs</label>
            </li>
            <li>
              <LazyImageWithNoscript
                src="/content/images/pharmacies-logo/safeway-logo.svg"
                alt=""
                height="24"
                width="24"
              />
              <label>Safeway</label>
            </li>
            <li>
              <LazyImageWithNoscript
                src="/content/images/pharmacies-logo/albertsons-logo.svg"
                alt=""
                height="24"
                width="24"
              />
              <label>Albertsons</label>
            </li>
            <li>
              <LazyImageWithNoscript
                src="/content/images/pharmacies-logo/meijer-logo.svg"
                alt=""
                height="24"
                width="24"
              />
              <label>Meijer</label>
            </li>
            <li>
              <LazyImageWithNoscript
                src="/content/images/pharmacies-logo/publix-logo.svg"
                alt=""
                height="24"
                width="24"
              />
              <label>Publix</label>
            </li>
            <li>
              <LazyImageWithNoscript
                src="/content/images/pharmacies-logo/costco-logo.svg"
                alt=""
                height="24"
                width="24"
              />
              <label>Costco</label>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default PharmaciesTableLogo;
